/**
 * @module features/forms
 */

export { default as reducer } from './reducer'

export {
  initForm,
  setFormErrors,
  setFieldErrors,
  focusField,
  touchField,
  touchAllFields,
  updateField,
  // Stepped Form
  initSteppedForm,
  startUpdating,
  stopUpdating,
  gotoPrevStep,
  gotoNextStep
} from './actions'
export * from './types'
